Auth = require 'db/auth'
ApiPromise = require 'network/api-promise'
Backgrounds = require 'data/backgrounds'
Dialog = require 'views/lib/dialog'
l = require 'lib/localize'
React = require 'react'
track = require 'debug/track'
trackUe = require 'debug/trackUe'
t = require('views/internal/recup-with-helpers')('board_background_prompt')
{ unsplashApi, toJson, constants } = require 'network/unsplash'
{ RAW_PARAMS } = constants
{ parseImageLink } = require 'lib/util'
PhotoAttributionComponent = require 'views/board-create/photo-attribution-component'
xtend = require 'xtend'

class BoardBackgroundPrompt extends React.Component
  displayName: 'BoardBackgroundPrompt'

  constructor: (props) ->
    super(props)

    @state = {
      loading: true
      image: null
      uploading: false
      isDemoing: false
    }

  componentWillMount: ->
    unsplashApi.photos.getPhoto('PdGBci-4jR8')
      .then(toJson)
      .then((image) =>
        @setState({ image, loading: false, })
      )
      .catch((err) => {
        # Just dont show the popover
      })

  onTry: ->
    { model } = @props
    { image } = @state
    track('Board Menu', 'Change Background', "unsplash-#{image.id}")
    trackUe('Board Background Prompt', 'Try Background')

    unsplashApi.photos.downloadPhoto(image)

    @setState({ uploading: true, })

    ApiPromise(
      url: "/1/boards/#{model.attributes.id}/prefs/background"
      type: 'post'
      data:
        url: parseImageLink(image.urls.raw, RAW_PARAMS)
    ).finally(=>
      @setState({ uploading: false, isDemoing: true, })
    )

  onKeep: ->
    Auth.me().dismiss('board-background-prompt')
    trackUe('Board Background Prompt', 'Keep photo')
    @props.onDismiss()

  onBrowse: ->
    Auth.me().dismiss('board-background-prompt')
    trackUe('Board Background Prompt', 'Browse')
    @props.onBrowse()

  onCancel: ->
    { model, onDismiss } = @props
    Auth.me().dismiss('board-background-prompt')
    trackUe('Board Background Prompt', 'Cancel')

    background = model.viewState.get('initialBackgroundColor') || 'blue'
    model
      .set
        prefs:
          background: background
          backgroundColor: Backgrounds[background].color
          backgroundBrightness: Backgrounds[background].brightness
          backgroundImage: null
          backgroundImageScaled: null
      .setPref 'background', background

    onDismiss()

  render: t.renderable ->
    if @state.loading
      return t.div '.board-background-prompt-noop'

    { image, uploading, isDemoing } = @state

    t.div '.board-background-prompt', =>
      t.div '.board-background-prompt--image', {
        style: {
          backgroundImage: "url(#{image.urls.small})"
        }
      }, =>
        if uploading
          t.addElement(
            React.createElement(
              'div',
              { className: 'uploading' },
              React.createElement(
                'span',
                { className: 'spinner small u-float-left' }
              ),
              l(['templates', 'board_background_selection', 'uploading-ellipsis'])
            )
          )
        else
          t.createElement PhotoAttributionComponent,
            user: image.user
            active: true
      t.div '.board-background-prompt--inner', =>
        t.h4 =>
          t.format 'add-some-pizzazz'
        if !isDemoing
          t.button '.primary.board-background-prompt--item', {
            onClick: => @onTry()
          }, =>
            t.format 'give-it-a-try'
        else
          t.button '.primary.board-background-prompt--item', {
            onClick: => @onKeep()
          }, =>
            t.format 'keep-this-photo'
        t.button '.board-background-prompt--item', {
          onClick: => @onBrowse()
        }, =>
          t.format 'browse-more'
        t.a '.board-background-prompt--item', {
          onClick: => @onCancel(),
          href: '#'
        }, =>
          if isDemoing
            t.format 'cancel-keep-my-background'
          else
            t.format 'no-thanks-dismiss'

module.exports = BoardBackgroundPrompt



// WEBPACK FOOTER //
// ./app/scripts/views/board/board-background-prompt.coffee